import { IS_CLIENT, IS_PRODUCTION } from '@repo/common-utils';

import { KakaoPixelEventParams, KakaoPixelInitializeProps, KakaoPixelMethods } from '../types';

export class KakaoPixelService {
  private readonly pixelId: string;
  private isInit: boolean = false;
  private preservedEvents: { methodName: KakaoPixelMethods; eventParams?: KakaoPixelEventParams }[] = [];
  private retryCount: number = 0;
  private retryTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor({ kakaoPixelId }: KakaoPixelInitializeProps) {
    this.pixelId = kakaoPixelId ?? '';

    if (this.pixelId) {
      this.init();
    }
  }

  private init() {
    if (!IS_CLIENT) return;
    this.sendInitEvent();
  }

  sendEvent(methodName: KakaoPixelMethods, eventParams?: KakaoPixelEventParams) {
    if (!this.isInit || !window.kakaoPixel) {
      this.preservedEvents.push({ methodName, eventParams });
      return;
    }

    setTimeout(() => {
      window.kakaoPixel(this.pixelId)[methodName](eventParams);
      this.printLog(methodName, eventParams);
    }, 200);
  }

  private sendInitEvent() {
    if (window.kakaoPixel) {
      this.isInit = true;
      this.preservedEvents.forEach((event) => this.sendEvent(event.methodName, event.eventParams));
      this.preservedEvents = [];
    } else if (this.retryCount < 10) {
      if (this.retryTimeout) clearTimeout(this.retryTimeout);
      this.retryTimeout = setTimeout(() => {
        this.retryCount++;
        this.sendInitEvent();
      }, 500);
    }
  }

  private printLog(methodName: string, eventParams?: Record<string, unknown> | string) {
    if (!IS_PRODUCTION && process.env.NEXT_PUBLIC_TRACKING_DEBUG_MODE === 'true') {
      console.info('%c[KakaoPixel]', 'font-weight: bold;', methodName, eventParams);
    }
  }
}
